// Locale-aware relative time string. The wording comes from
// Intl.RelativeTimeFormat — never a hardcoded phrase — so a user with their
// browser in, say, Spanish sees "hace 5 minutos" without us shipping a phrase
// list. Pass `locale` to override the runtime default.

const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

function pickUnit(absSeconds) {
  if (absSeconds < 45) return { unit: 'second', divisor: SECOND }
  if (absSeconds < 45 * 60) return { unit: 'minute', divisor: MINUTE }
  if (absSeconds < 22 * 60 * 60) return { unit: 'hour', divisor: HOUR }
  if (absSeconds < 26 * 24 * 60 * 60) return { unit: 'day', divisor: DAY }
  if (absSeconds < 320 * 24 * 60 * 60) return { unit: 'month', divisor: 30.44 * DAY }
  return { unit: 'year', divisor: 365.25 * DAY }
}

export function relativeTimeLabel(targetMs, nowMs = Date.now(), locale) {
  if (targetMs == null) return ''
  const target = targetMs instanceof Date ? targetMs.getTime() : Number(targetMs)
  if (!Number.isFinite(target)) return ''
  const loc = locale ?? (typeof navigator !== 'undefined' ? navigator.language : undefined)
  const diffSeconds = (target - nowMs) / 1000
  const { unit, divisor } = pickUnit(Math.abs(diffSeconds))
  const value = Math.round((diffSeconds * 1000) / divisor)
  return new Intl.RelativeTimeFormat(loc, { numeric: 'auto' }).format(value, unit)
}
